import { DefaultTemplate, COR, CORES_SIM_NAO } from './types';

// ============================================================
// INCORPORAÇÃO / IMOBILIÁRIO
//
// O lado de quem compra terreno, aprova projeto, vende e aluga unidade.
// A parte de execução de obra está em ./obras.ts.
// ============================================================

const viabilidadeTerreno: DefaultTemplate = {
  id: 'tpl_viabilidade_terreno',
  name: 'Viabilidade de Terreno',
  descricao: 'Prospecção de área até a escritura: estudo de massa e VGV, due diligence de matrícula e certidões, viabilidade econômica com TIR e decisão do comitê. Para incorporadora não comprar problema.',
  categoria: 'imobiliario',
  icone: '🏢',
  etiquetas: [
    { nome: 'Permuta', cor: COR.roxo },
    { nome: 'Oportunidade', cor: COR.verde },
    { nome: 'Risco Jurídico', cor: COR.vermelho },
  ],
  etapas: [
    {
      id: 'vt_e1', nome: 'Prospecção',
      tempoMaximoHoras: 72,
      camposVisiveisNoCard: ['vt_c1', 'vt_c3', 'vt_c6'],
      permiteMoverPara: ['vt_e2'],
      campos: [
        { id: 'vt_c1', nome: 'Identificação da Área', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'vt_c2', nome: 'Endereço', tipo: 'texto', obrigatorio: true },
        { id: 'vt_c3', nome: 'Área do Terreno (m²)', tipo: 'numero', obrigatorio: true },
        { id: 'vt_c4', nome: 'Proprietário', tipo: 'texto', obrigatorio: false },
        { id: 'vt_c5', nome: 'Contato', tipo: 'telefone', obrigatorio: false },
        { id: 'vt_c6', nome: 'Preço Pedido', tipo: 'valor', obrigatorio: false },
        { id: 'vt_c7', nome: 'Matrícula do Imóvel', tipo: 'texto', obrigatorio: false },
        { id: 'vt_c8', nome: 'Zoneamento', tipo: 'texto', obrigatorio: false },
        { id: 'vt_c9', nome: 'Forma Pretendida', tipo: 'lista', obrigatorio: false, opcoes: ['Compra à vista', 'Compra parcelada', 'Permuta física', 'Permuta financeira', 'Permuta mista'], coresOpcoes: { 'Permuta física': COR.roxo, 'Permuta mista': COR.roxo } },
        { id: 'vt_c10', nome: 'Origem da Indicação', tipo: 'texto', obrigatorio: false },
        { id: 'vt_c11', nome: 'Fotos / Localização', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'vt_e2', nome: 'Estudo de Massa',
      tempoMaximoHoras: 120,
      camposVisiveisNoCard: ['vt_c1', 'vt_c13', 'vt_c15'],
      permiteMoverPara: ['vt_e3', 'vt_e7'],
      permiteCriarCards: false,
      campos: [
        { id: 'vt_c12', nome: 'Produto Sugerido', tipo: 'lista', obrigatorio: true, opcoes: ['Residencial vertical', 'Residencial horizontal', 'Loteamento', 'Comercial / Salas', 'Misto', 'Galpão / Logístico'] },
        { id: 'vt_c13', nome: 'Nº de Unidades Previstas', tipo: 'numero', obrigatorio: false },
        { id: 'vt_c14', nome: 'Área Privativa Total (m²)', tipo: 'numero', obrigatorio: false },
        { id: 'vt_c15', nome: 'VGV Estimado', tipo: 'valor', obrigatorio: true },
        { id: 'vt_c16', nome: 'Coeficiente de Aproveitamento', tipo: 'numero', obrigatorio: false },
        { id: 'vt_c17', nome: 'Restrições Urbanísticas', tipo: 'texto_longo', obrigatorio: false },
        { id: 'vt_c18', nome: 'Estudo de Massa (arquivo)', tipo: 'anexo', obrigatorio: false },
        { id: 'vt_c19', nome: 'Produto viável?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'vt_e3', nome: 'Due Diligence Jurídica',
      tempoMaximoHoras: 168,
      camposVisiveisNoCard: ['vt_c1', 'vt_c21'],
      permiteMoverPara: ['vt_e4', 'vt_e7'],
      permiteCriarCards: false,
      campos: [
        { id: 'vt_c20', nome: 'Documentos Analisados', tipo: 'checkbox_multi', obrigatorio: false, opcoes: ['Matrícula atualizada', 'Certidões do proprietário', 'Certidão negativa de ônus', 'Ações cíveis e trabalhistas', 'Certidão de IPTU', 'Certidão ambiental', 'Cadeia dominial (20 anos)', 'Inventário / espólio'] },
        { id: 'vt_c21', nome: 'Situação Jurídica', tipo: 'lista', obrigatorio: true, opcoes: ['Limpa', 'Com ressalva contornável', 'Com risco relevante', 'Inviável'], coresOpcoes: { 'Limpa': COR.verde, 'Com ressalva contornável': COR.amarelo, 'Com risco relevante': COR.vermelho, 'Inviável': COR.vermelho } },
        { id: 'vt_c22', nome: 'Ônus / Pendências Encontradas', tipo: 'texto_longo', obrigatorio: false },
        { id: 'vt_c23', nome: 'Parecer Jurídico', tipo: 'anexo', obrigatorio: false },
        { id: 'vt_c24', nome: 'Aprovado juridicamente?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'vt_e4', nome: 'Viabilidade Econômica',
      tempoMaximoHoras: 120,
      camposVisiveisNoCard: ['vt_c1', 'vt_c15', 'vt_c27'],
      permiteMoverPara: ['vt_e5', 'vt_e7'],
      permiteCriarCards: false,
      campos: [
        { id: 'vt_c25', nome: 'Custo de Obra Estimado', tipo: 'valor', obrigatorio: false },
        { id: 'vt_c26', nome: 'Custo do Terreno', tipo: 'valor', obrigatorio: false },
        { id: 'vt_c27', nome: 'Margem Prevista (%)', tipo: 'numero', obrigatorio: false },
        { id: 'vt_c28', nome: 'TIR Estimada (%)', tipo: 'numero', obrigatorio: false },
        { id: 'vt_c29', nome: 'Exposição Máxima de Caixa', tipo: 'valor', obrigatorio: false },
        { id: 'vt_c30', nome: 'Prazo Total do Projeto (meses)', tipo: 'numero', obrigatorio: false },
        { id: 'vt_c31', nome: 'Planilha de Viabilidade', tipo: 'anexo', obrigatorio: false },
        { id: 'vt_c32', nome: 'Viável economicamente?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'vt_e5', nome: 'Comitê de Investimento',
      tempoMaximoHoras: 168,
      camposVisiveisNoCard: ['vt_c1', 'vt_c15', 'vt_c33'],
      permiteMoverPara: ['vt_e6', 'vt_e7'],
      permiteCriarCards: false,
      limparCamposAoRetornar: ['vt_c33', 'vt_c35'],
      campos: [
        { id: 'vt_c33', nome: 'Decisão do Comitê', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'vt_c34', nome: 'Data da Reunião', tipo: 'data', obrigatorio: false },
        { id: 'vt_c35', nome: 'Condicionantes da Aprovação', tipo: 'texto_longo', obrigatorio: false },
        { id: 'vt_c36', nome: 'Ata / Parecer', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'vt_e6', nome: 'Aquisição',
      tempoMaximoHoras: 336,
      camposVisiveisNoCard: ['vt_c1', 'vt_c38', 'vt_c39'],
      permiteCriarCards: false,
      campos: [
        { id: 'vt_c37', nome: 'Valor Negociado', tipo: 'valor', obrigatorio: false },
        { id: 'vt_c38', nome: 'Etapa da Aquisição', tipo: 'lista', obrigatorio: false, opcoes: ['Proposta assinada', 'Contrato / Compromisso', 'Escritura lavrada', 'Registro concluído'], coresOpcoes: { 'Registro concluído': COR.verde } },
        { id: 'vt_c39', nome: 'Data do Registro', tipo: 'data', obrigatorio: false },
        { id: 'vt_c40', nome: 'Escritura / Contrato', tipo: 'anexo', obrigatorio: false },
        { id: 'vt_c41', nome: 'Matrícula Atualizada', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'vt_e7', nome: 'Descartado',
      camposVisiveisNoCard: ['vt_c1', 'vt_c42'],
      permiteMoverPara: ['vt_e1'],
      permiteCriarCards: false,
      campos: [
        { id: 'vt_c42', nome: 'Motivo do Descarte', tipo: 'lista', obrigatorio: true, opcoes: ['Preço do terreno', 'Zoneamento restritivo', 'Risco jurídico', 'Viabilidade negativa', 'Vendido para terceiro', 'Fora da estratégia'], coresOpcoes: { 'Risco jurídico': COR.vermelho, 'Viabilidade negativa': COR.vermelho } },
        { id: 'vt_c43', nome: 'Detalhamento', tipo: 'texto_longo', obrigatorio: false },
        { id: 'vt_c44', nome: 'Reavaliar em', tipo: 'data', obrigatorio: false },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Produto viável vai para o jurídico',
      etapaOrigemId: 'vt_e2',
      condicao: { campoId: 'vt_c19', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'vt_e3',
      etapaDestinoSenaoId: 'vt_e7',
    },
    {
      tipo: 'mover',
      nome: 'Jurídico aprovado libera a viabilidade econômica',
      etapaOrigemId: 'vt_e3',
      condicao: { campoId: 'vt_c24', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'vt_e4',
      etapaDestinoSenaoId: 'vt_e7',
    },
    {
      tipo: 'mover',
      nome: 'Viável economicamente vai ao comitê',
      etapaOrigemId: 'vt_e4',
      condicao: { campoId: 'vt_c32', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'vt_e5',
      etapaDestinoSenaoId: 'vt_e7',
    },
    {
      tipo: 'mover',
      nome: 'Comitê aprovou parte para aquisição',
      etapaOrigemId: 'vt_e5',
      condicao: { campoId: 'vt_c33', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'vt_e6',
      etapaDestinoSenaoId: 'vt_e7',
    },
    {
      tipo: 'exibir_ocultar',
      nome: 'Detalhar ônus quando houver pendência jurídica',
      etapaOrigemId: 'vt_e3',
      condicao: { campoId: 'vt_c24', operador: 'igual', valor: 'Não' },
      camposAfetadosIds: ['vt_c22'],
    },
  ],
  cards: [
    { id: 'vt_card1', titulo: 'Área Av. das Palmeiras - 3.200m²', etapaId: 'vt_e4', etiquetas: ['Permuta'], valores: { vt_c1: 'Área Av. das Palmeiras - 3.200m²', vt_c2: 'Av. das Palmeiras, 1200', vt_c3: 3200, vt_c6: 4800000, vt_c9: 'Permuta mista', vt_c12: 'Residencial vertical', vt_c13: 96, vt_c15: 42000000, vt_c27: 22 } },
    { id: 'vt_card2', titulo: 'Gleba Estrada do Sol - 18 alqueires', etapaId: 'vt_e3', valores: { vt_c1: 'Gleba Estrada do Sol - 18 alqueires', vt_c2: 'Estrada do Sol, km 8', vt_c3: 87000, vt_c6: 9200000, vt_c12: 'Loteamento', vt_c15: 68000000, vt_c21: 'Com ressalva contornável' } },
    { id: 'vt_card3', titulo: 'Esquina Centro - 850m²', etapaId: 'vt_e5', etiquetas: ['Oportunidade'], valores: { vt_c1: 'Esquina Centro - 850m²', vt_c2: 'Rua XV com Rua Sete', vt_c3: 850, vt_c6: 2600000, vt_c12: 'Misto', vt_c15: 19500000, vt_c27: 26, vt_c28: 31 } },
    { id: 'vt_card4', titulo: 'Terreno Bairro Jardim - 1.100m²', etapaId: 'vt_e2', valores: { vt_c1: 'Terreno Bairro Jardim - 1.100m²', vt_c2: 'Rua das Acácias, 340', vt_c3: 1100, vt_c6: 1750000, vt_c12: 'Residencial vertical' } },
    { id: 'vt_card5', titulo: 'Área Industrial Rodovia BR - 12.000m²', etapaId: 'vt_e6', valores: { vt_c1: 'Área Industrial Rodovia BR - 12.000m²', vt_c2: 'BR-153, km 42', vt_c3: 12000, vt_c12: 'Galpão / Logístico', vt_c15: 34000000, vt_c37: 6900000, vt_c38: 'Escritura lavrada' } },
    { id: 'vt_card6', titulo: 'Chácara Vale Verde - 5.000m²', etapaId: 'vt_e7', etiquetas: ['Risco Jurídico'], valores: { vt_c1: 'Chácara Vale Verde - 5.000m²', vt_c2: 'Rodovia Municipal, km 3', vt_c3: 5000, vt_c42: 'Risco jurídico', vt_c43: 'Área em inventário com quatro herdeiros e um deles em ação de usucapião.' } },
    { id: 'vt_card7', titulo: 'Lote Comercial Av. Brasil - 640m²', etapaId: 'vt_e1', valores: { vt_c1: 'Lote Comercial Av. Brasil - 640m²', vt_c2: 'Av. Brasil, 2100', vt_c3: 640, vt_c6: 1400000, vt_c10: 'Corretor parceiro' } },
  ],
  tour: [
    '🏢 Terreno só vira empreendimento depois de passar por quatro peneiras.',
    '1️⃣ "Prospecção": endereço, área, matrícula e preço pedido.',
    '2️⃣ "Estudo de Massa": quantas unidades cabem e qual VGV isso gera.',
    '3️⃣ "Due Diligence": matrícula, ônus, espólio, certidões — risco jurídico descarta na hora.',
    '4️⃣ "Viabilidade Econômica": margem, TIR e exposição de caixa na mesa.',
    '5️⃣ "Comitê": decisão registrada com ata e condicionantes.',
    '📜 "Aquisição": acompanha até o registro da matrícula, que é quando o terreno é seu de verdade.',
    '🗂️ "Descartado" guarda o histórico — terreno recusado hoje pode voltar em outro preço.',
  ],
  etapasDicas: [
    { quemFaz: 'Prospecção / Novos Negócios', objetivo: 'Registrar toda área ofertada, mesmo as que parecem caras.' },
    { quemFaz: 'Arquitetura / Produto', objetivo: 'Descobrir cedo quanto o terreno realmente comporta.', automacoes: ['Já configurado: produto inviável vai para descartado'] },
    { quemFaz: 'Jurídico', objetivo: 'Achar o problema antes da escritura, não depois.', automacoes: ['Já configurado: reprovado juridicamente descarta'] },
    { quemFaz: 'Financeiro / Incorporação', objetivo: 'Calcular margem, TIR e exposição máxima de caixa.' },
    { quemFaz: 'Sócios / Comitê', objetivo: 'Decidir com todos os pareceres no mesmo card.' },
    { quemFaz: 'Jurídico / Diretoria', objetivo: 'Levar até o registro — só aí a aquisição está concluída.', conexoes: ['Ligue à "Aprovação de Projetos e Licenças" para iniciar a legalização'] },
    { quemFaz: 'Novos Negócios', objetivo: 'Guardar o motivo e a data para reavaliar.' },
  ],
};

const aprovacaoProjetos: DefaultTemplate = {
  id: 'tpl_aprovacao_projetos',
  name: 'Aprovação de Projetos e Licenças',
  descricao: 'Legalização do empreendimento: projeto legal, protocolo em prefeitura, bombeiros, ambiental e concessionárias, controle de comunique-se com prazo e emissão do alvará. Nada de exigência vencendo esquecida.',
  categoria: 'imobiliario',
  icone: '📜',
  etiquetas: [
    { nome: 'Prazo Legal', cor: COR.vermelho },
    { nome: 'Comunique-se', cor: COR.amarelo },
    { nome: 'Licença Emitida', cor: COR.verde },
  ],
  etapas: [
    {
      id: 'ap_e1', nome: 'Levantamento de Exigências',
      tempoMaximoHoras: 72,
      camposVisiveisNoCard: ['ap_c1', 'ap_c2', 'ap_c3'],
      permiteMoverPara: ['ap_e2'],
      campos: [
        { id: 'ap_c1', nome: 'Licença / Aprovação', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'ap_c2', nome: 'Empreendimento', tipo: 'texto', obrigatorio: true },
        { id: 'ap_c3', nome: 'Órgão', tipo: 'lista', obrigatorio: true, opcoes: ['Prefeitura', 'Corpo de Bombeiros', 'Órgão Ambiental', 'Vigilância Sanitária', 'Concessionária de Água', 'Concessionária de Energia', 'Cartório de Registro', 'CREA / CAU', 'Outro'], coresOpcoes: { 'Prefeitura': COR.azul, 'Corpo de Bombeiros': COR.vermelho, 'Órgão Ambiental': COR.verde } },
        { id: 'ap_c4', nome: 'Tipo de Processo', tipo: 'lista', obrigatorio: false, opcoes: ['Aprovação de projeto', 'Alvará de construção', 'Licença ambiental prévia', 'Licença de instalação', 'Licença de operação', 'AVCB / Projeto de incêndio', 'Habite-se / CVCO', 'Registro de incorporação', 'Viabilidade de ligação'] },
        { id: 'ap_c5', nome: 'Documentos Exigidos', tipo: 'texto_longo', obrigatorio: false },
        { id: 'ap_c6', nome: 'Responsável Técnico', tipo: 'texto', obrigatorio: false },
        { id: 'ap_c7', nome: 'Prazo Legal Estimado', tipo: 'texto', obrigatorio: false },
        { id: 'ap_c8', nome: 'Taxa Prevista', tipo: 'valor', obrigatorio: false },
      ],
    },
    {
      id: 'ap_e2', nome: 'Projeto e Documentação',
      tempoMaximoHoras: 240,
      camposVisiveisNoCard: ['ap_c1', 'ap_c10'],
      permiteMoverPara: ['ap_e3'],
      permiteCriarCards: false,
      campos: [
        { id: 'ap_c9', nome: 'Peças Necessárias', tipo: 'checkbox_multi', obrigatorio: false, opcoes: ['Projeto arquitetônico', 'Projeto estrutural', 'Projeto elétrico', 'Projeto hidrossanitário', 'Projeto de incêndio', 'Memorial descritivo', 'ART / RRT', 'Matrícula atualizada', 'Levantamento topográfico', 'Estudo de impacto'] },
        { id: 'ap_c10', nome: 'Documentação completa?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'ap_c11', nome: 'Projetista / Escritório', tipo: 'texto', obrigatorio: false },
        { id: 'ap_c12', nome: 'Arquivos do Projeto', tipo: 'anexo', obrigatorio: false },
        { id: 'ap_c13', nome: 'Progresso da Montagem', tipo: 'progresso', obrigatorio: false },
      ],
    },
    {
      id: 'ap_e3', nome: 'Protocolado',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['ap_c1', 'ap_c14', 'ap_c16'],
      permiteMoverPara: ['ap_e4'],
      permiteCriarCards: false,
      campos: [
        { id: 'ap_c14', nome: 'Nº do Protocolo', tipo: 'texto', obrigatorio: true },
        { id: 'ap_c15', nome: 'Data do Protocolo', tipo: 'data', obrigatorio: true },
        { id: 'ap_c16', nome: 'Previsão de Retorno do Órgão', tipo: 'data_vencimento', obrigatorio: false },
        { id: 'ap_c17', nome: 'Taxa Paga', tipo: 'valor', obrigatorio: false },
        { id: 'ap_c18', nome: 'Comprovante de Protocolo', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'ap_e4', nome: 'Em Análise do Órgão',
      camposVisiveisNoCard: ['ap_c1', 'ap_c14', 'ap_c19'],
      permiteMoverPara: ['ap_e5', 'ap_e6', 'ap_e7'],
      permiteCriarCards: false,
      ordenacaoCards: 'vencimento_proximo',
      campos: [
        { id: 'ap_c19', nome: 'Situação', tipo: 'lista', obrigatorio: false, opcoes: ['Aguardando análise', 'Em análise técnica', 'Aguardando vistoria', 'Aguardando assinatura'], coresOpcoes: { 'Aguardando vistoria': COR.amarelo } },
        { id: 'ap_c20', nome: 'Houve exigência / comunique-se?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'ap_c21', nome: 'Último Contato com o Órgão', tipo: 'data', obrigatorio: false },
        { id: 'ap_c22', nome: 'Andamento', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'ap_e5', nome: 'Exigências a Cumprir',
      tempoMaximoHoras: 120,
      camposVisiveisNoCard: ['ap_c1', 'ap_c24', 'ap_c25'],
      permiteMoverPara: ['ap_e3', 'ap_e4'],
      permiteCriarCards: false,
      ordenacaoCards: 'vencimento_proximo',
      campos: [
        { id: 'ap_c23', nome: 'Exigências do Órgão', tipo: 'texto_longo', obrigatorio: true },
        { id: 'ap_c24', nome: 'Prazo para Resposta', tipo: 'data_vencimento', obrigatorio: true },
        { id: 'ap_c25', nome: 'Responsável pela Resposta', tipo: 'texto', obrigatorio: false },
        { id: 'ap_c26', nome: 'Ofício / Comunique-se', tipo: 'anexo', obrigatorio: false },
        { id: 'ap_c27', nome: 'Exigências atendidas?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'ap_c28', nome: 'Resposta Protocolada', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'ap_e6', nome: 'Licença Emitida',
      camposVisiveisNoCard: ['ap_c1', 'ap_c29', 'ap_c30'],
      permiteCriarCards: false,
      campos: [
        { id: 'ap_c29', nome: 'Nº da Licença / Alvará', tipo: 'texto', obrigatorio: false },
        { id: 'ap_c30', nome: 'Validade', tipo: 'data_vencimento', obrigatorio: false },
        { id: 'ap_c31', nome: 'Data de Emissão', tipo: 'data', obrigatorio: false },
        { id: 'ap_c32', nome: 'Documento Emitido', tipo: 'anexo', obrigatorio: false },
        { id: 'ap_c33', nome: 'Condicionantes a Cumprir', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'ap_e7', nome: 'Indeferido',
      camposVisiveisNoCard: ['ap_c1', 'ap_c34'],
      permiteMoverPara: ['ap_e2'],
      permiteCriarCards: false,
      campos: [
        { id: 'ap_c34', nome: 'Motivo do Indeferimento', tipo: 'texto_longo', obrigatorio: true },
        { id: 'ap_c35', nome: 'Vai recorrer?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'ap_c36', nome: 'Estratégia de Recurso', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Documentação completa vai para protocolo',
      etapaOrigemId: 'ap_e2',
      condicao: { campoId: 'ap_c10', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'ap_e3',
    },
    {
      tipo: 'mover',
      nome: 'Comunique-se abre a etapa de exigências',
      etapaOrigemId: 'ap_e4',
      condicao: { campoId: 'ap_c20', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'ap_e5',
    },
    {
      tipo: 'mover',
      nome: 'Exigências atendidas voltam para análise',
      etapaOrigemId: 'ap_e5',
      condicao: { campoId: 'ap_c27', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'ap_e4',
    },
    {
      tipo: 'exibir_ocultar',
      nome: 'Estratégia de recurso só quando for recorrer',
      etapaOrigemId: 'ap_e7',
      condicao: { campoId: 'ap_c35', operador: 'igual', valor: 'Sim' },
      camposAfetadosIds: ['ap_c36'],
    },
  ],
  cards: [
    { id: 'ap_card1', titulo: 'Alvará de construção - Vista Verde', etapaId: 'ap_e5', etiquetas: ['Comunique-se', 'Prazo Legal'], valores: { ap_c1: 'Alvará de construção - Vista Verde', ap_c2: 'Residencial Vista Verde', ap_c3: 'Prefeitura', ap_c4: 'Alvará de construção', ap_c14: '2026/044871', ap_c23: 'Ajustar taxa de permeabilidade e reapresentar planta de situação.', ap_c24: '2026-08-25' } },
    { id: 'ap_card2', titulo: 'AVCB - Edifício Prime', etapaId: 'ap_e4', valores: { ap_c1: 'AVCB - Edifício Prime', ap_c2: 'Edifício Comercial Prime', ap_c3: 'Corpo de Bombeiros', ap_c4: 'AVCB / Projeto de incêndio', ap_c14: 'CB-2026-1188', ap_c19: 'Aguardando vistoria' } },
    { id: 'ap_card3', titulo: 'Licença ambiental prévia - Alto da Serra', etapaId: 'ap_e2', valores: { ap_c1: 'Licença ambiental prévia - Alto da Serra', ap_c2: 'Condomínio Alto da Serra', ap_c3: 'Órgão Ambiental', ap_c4: 'Licença ambiental prévia', ap_c13: 70 } },
    { id: 'ap_card4', titulo: 'Registro de incorporação - Torre A', etapaId: 'ap_e6', etiquetas: ['Licença Emitida'], valores: { ap_c1: 'Registro de incorporação - Torre A', ap_c2: 'Residencial Vista Verde', ap_c3: 'Cartório de Registro', ap_c4: 'Registro de incorporação', ap_c29: 'R.12-45.221' } },
    { id: 'ap_card5', titulo: 'Habite-se - Centro Clínico', etapaId: 'ap_e1', valores: { ap_c1: 'Habite-se - Centro Clínico', ap_c2: 'Centro Clínico Bela Vista', ap_c3: 'Prefeitura', ap_c4: 'Habite-se / CVCO' } },
    { id: 'ap_card6', titulo: 'Viabilidade de energia - CD Sul', etapaId: 'ap_e3', valores: { ap_c1: 'Viabilidade de energia - CD Sul', ap_c2: 'Galpão Logístico CD Sul', ap_c3: 'Concessionária de Energia', ap_c4: 'Viabilidade de ligação', ap_c14: 'VE-88214' } },
    { id: 'ap_card7', titulo: 'Aprovação de projeto - Lote 12', etapaId: 'ap_e7', valores: { ap_c1: 'Aprovação de projeto - Lote 12', ap_c2: 'Alto da Serra', ap_c3: 'Prefeitura', ap_c34: 'Recuo frontal abaixo do exigido pelo novo plano diretor.', ap_c35: 'Sim' } },
  ],
  tour: [
    '📜 Cada licença é um card — e cada prazo do órgão vira cobrança automática.',
    '1️⃣ "Levantamento": o que o órgão exige antes de montar o processo.',
    '2️⃣ "Projeto e Documentação": checklist de peças e barra de progresso.',
    '3️⃣ "Protocolado": número do protocolo é a chave de tudo, fica no card.',
    '4️⃣ "Em Análise": marcou comunique-se? o card pula direto para exigências.',
    '5️⃣ "Exigências": prazo de resposta é data de vencimento — perder prazo aqui arquiva o processo.',
    '✅ "Licença Emitida": validade fica registrada para renovar antes de vencer.',
  ],
  etapasDicas: [
    { quemFaz: 'Legalização / Arquitetura', objetivo: 'Mapear exigências antes de montar o processo.' },
    { quemFaz: 'Projetista / Escritório', objetivo: 'Fechar todas as peças e ARTs antes de protocolar.', automacoes: ['Já configurado: documentação completa vai para protocolo'] },
    { quemFaz: 'Despachante / Legalização', objetivo: 'Registrar protocolo e previsão de retorno.' },
    { quemFaz: 'Legalização', objetivo: 'Acompanhar o andamento sem depender da memória de ninguém.', automacoes: ['Já configurado: comunique-se abre a etapa de exigências'] },
    { quemFaz: 'Projetista / Legalização', objetivo: 'Responder dentro do prazo — os cards se ordenam pelo vencimento.', automacoes: ['Já configurado: exigência atendida volta para análise'] },
    { quemFaz: 'Legalização', objetivo: 'Guardar o documento e a validade.', conexoes: ['Ligue à "Execução de Obra" — sem alvará a obra não mobiliza'] },
    { quemFaz: 'Jurídico / Arquitetura', objetivo: 'Decidir entre recorrer ou refazer o projeto.' },
  ],
};

const vendasImoveis: DefaultTemplate = {
  id: 'tpl_vendas_imoveis',
  name: 'Vendas de Imóveis',
  descricao: 'Funil imobiliário completo: atendimento, visita, proposta, análise de crédito e financiamento, contrato, registro em cartório e comissão. Do lead ao repasse concluído.',
  categoria: 'imobiliario',
  icone: '🔑',
  etiquetas: [
    { nome: 'Financiamento', cor: COR.azul },
    { nome: 'À Vista', cor: COR.verde },
    { nome: 'Permuta', cor: COR.roxo },
    { nome: 'Cliente Quente', cor: COR.vermelho },
  ],
  etapas: [
    {
      id: 'vi_e1', nome: 'Atendimento / Lead',
      tempoMaximoHoras: 24,
      camposVisiveisNoCard: ['vi_c1', 'vi_c4', 'vi_c6'],
      permiteMoverPara: ['vi_e2', 'vi_e8'],
      campos: [
        { id: 'vi_c1', nome: 'Cliente', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'vi_c2', nome: 'Telefone', tipo: 'telefone', obrigatorio: true },
        { id: 'vi_c3', nome: 'E-mail', tipo: 'texto', obrigatorio: false },
        { id: 'vi_c4', nome: 'Imóvel de Interesse', tipo: 'texto', obrigatorio: true },
        { id: 'vi_c5', nome: 'Origem do Lead', tipo: 'lista', obrigatorio: false, opcoes: ['Portal imobiliário', 'Site próprio', 'Indicação', 'Plantão de vendas', 'Redes sociais', 'Placa no imóvel', 'Corretor parceiro'] },
        { id: 'vi_c6', nome: 'Faixa de Valor Buscada', tipo: 'valor', obrigatorio: false },
        { id: 'vi_c7', nome: 'Forma de Pagamento Pretendida', tipo: 'lista', obrigatorio: false, opcoes: ['Financiamento bancário', 'À vista', 'Parcelado direto', 'FGTS + financiamento', 'Permuta'], coresOpcoes: { 'À vista': COR.verde, 'Permuta': COR.roxo } },
        { id: 'vi_c8', nome: 'Corretor Responsável', tipo: 'texto', obrigatorio: false },
        { id: 'vi_c9', nome: 'Observações do Atendimento', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'vi_e2', nome: 'Visita',
      tempoMaximoHoras: 72,
      camposVisiveisNoCard: ['vi_c1', 'vi_c4', 'vi_c10'],
      permiteMoverPara: ['vi_e3', 'vi_e8'],
      permiteCriarCards: false,
      campos: [
        { id: 'vi_c10', nome: 'Data da Visita', tipo: 'data', obrigatorio: false },
        { id: 'vi_c11', nome: 'Imóveis Apresentados', tipo: 'texto_longo', obrigatorio: false },
        { id: 'vi_c12', nome: 'Interesse do Cliente', tipo: 'lista', obrigatorio: false, opcoes: ['Alto', 'Médio', 'Baixo'], coresOpcoes: { 'Alto': COR.verde, 'Médio': COR.amarelo, 'Baixo': COR.cinza } },
        { id: 'vi_c13', nome: 'Objeções Levantadas', tipo: 'texto_longo', obrigatorio: false },
        { id: 'vi_c14', nome: 'Vai fazer proposta?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'vi_e3', nome: 'Proposta',
      tempoMaximoHoras: 72,
      camposVisiveisNoCard: ['vi_c1', 'vi_c15', 'vi_c18'],
      permiteMoverPara: ['vi_e4', 'vi_e8'],
      permiteCriarCards: false,
      limparCamposAoRetornar: ['vi_c18', 'vi_c19'],
      campos: [
        { id: 'vi_c15', nome: 'Valor Proposto', tipo: 'valor', obrigatorio: true },
        { id: 'vi_c16', nome: 'Valor de Entrada', tipo: 'valor', obrigatorio: false },
        { id: 'vi_c17', nome: 'Condições da Proposta', tipo: 'texto_longo', obrigatorio: false },
        { id: 'vi_c18', nome: 'Proposta aceita?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'vi_c19', nome: 'Contraproposta', tipo: 'texto_longo', obrigatorio: false },
        { id: 'vi_c20', nome: 'Proposta Assinada', tipo: 'anexo', obrigatorio: false },
        { id: 'vi_c21', nome: 'Validade da Proposta', tipo: 'data_vencimento', obrigatorio: false },
      ],
    },
    {
      id: 'vi_e4', nome: 'Análise de Crédito',
      tempoMaximoHoras: 240,
      camposVisiveisNoCard: ['vi_c1', 'vi_c22', 'vi_c25'],
      permiteMoverPara: ['vi_e5', 'vi_e8'],
      permiteCriarCards: false,
      campos: [
        { id: 'vi_c22', nome: 'Banco / Instituição', tipo: 'texto', obrigatorio: false },
        { id: 'vi_c23', nome: 'Documentos do Cliente', tipo: 'checkbox_multi', obrigatorio: false, opcoes: ['RG e CPF', 'Comprovante de renda', 'Comprovante de residência', 'Certidão de estado civil', 'Extrato do FGTS', 'Imposto de renda', 'Certidões negativas'] },
        { id: 'vi_c24', nome: 'Valor Financiado', tipo: 'valor', obrigatorio: false },
        { id: 'vi_c25', nome: 'Crédito aprovado?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'vi_c26', nome: 'Laudo de Avaliação do Banco', tipo: 'anexo', obrigatorio: false },
        { id: 'vi_c27', nome: 'Motivo da Recusa do Crédito', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'vi_e5', nome: 'Contrato',
      tempoMaximoHoras: 168,
      camposVisiveisNoCard: ['vi_c1', 'vi_c15', 'vi_c29'],
      permiteMoverPara: ['vi_e6'],
      permiteCriarCards: false,
      campos: [
        { id: 'vi_c28', nome: 'Tipo de Instrumento', tipo: 'lista', obrigatorio: false, opcoes: ['Contrato de compra e venda', 'Promessa de compra e venda', 'Contrato de financiamento', 'Escritura pública'] },
        { id: 'vi_c29', nome: 'Contrato assinado?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'vi_c30', nome: 'Data da Assinatura', tipo: 'data', obrigatorio: false },
        { id: 'vi_c31', nome: 'Contrato (PDF)', tipo: 'anexo', obrigatorio: false },
        { id: 'vi_c32', nome: 'Sinal Recebido', tipo: 'valor', obrigatorio: false },
      ],
    },
    {
      id: 'vi_e6', nome: 'Repasse e Registro',
      tempoMaximoHoras: 480,
      camposVisiveisNoCard: ['vi_c1', 'vi_c33', 'vi_c35'],
      permiteMoverPara: ['vi_e7'],
      permiteCriarCards: false,
      ordenacaoCards: 'vencimento_proximo',
      campos: [
        { id: 'vi_c33', nome: 'Etapa do Repasse', tipo: 'lista', obrigatorio: false, opcoes: ['Documentação no banco', 'Contrato no cartório', 'Aguardando registro', 'Registrado', 'Recurso liberado'], coresOpcoes: { 'Recurso liberado': COR.verde, 'Aguardando registro': COR.amarelo } },
        { id: 'vi_c34', nome: 'Cartório', tipo: 'texto', obrigatorio: false },
        { id: 'vi_c35', nome: 'Previsão de Liberação', tipo: 'data_vencimento', obrigatorio: false },
        { id: 'vi_c36', nome: 'Custas e ITBI', tipo: 'valor', obrigatorio: false },
        { id: 'vi_c37', nome: 'Matrícula Registrada', tipo: 'anexo', obrigatorio: false },
        { id: 'vi_c38', nome: 'Recurso liberado?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'vi_e7', nome: 'Venda Concluída',
      camposVisiveisNoCard: ['vi_c1', 'vi_c15', 'vi_c40'],
      permiteCriarCards: false,
      campos: [
        { id: 'vi_c39', nome: 'Data de Entrega das Chaves', tipo: 'data', obrigatorio: false },
        { id: 'vi_c40', nome: 'Comissão a Pagar', tipo: 'valor', obrigatorio: false },
        { id: 'vi_c41', nome: 'Comissão paga?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'vi_c42', nome: 'Termo de Entrega', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'vi_e8', nome: 'Perdido',
      camposVisiveisNoCard: ['vi_c1', 'vi_c43'],
      permiteMoverPara: ['vi_e1'],
      permiteCriarCards: false,
      campos: [
        { id: 'vi_c43', nome: 'Motivo da Perda', tipo: 'lista', obrigatorio: true, opcoes: ['Preço acima do orçamento', 'Crédito não aprovado', 'Comprou de concorrente', 'Desistiu da compra', 'Sem retorno do cliente', 'Imóvel não atendeu'], coresOpcoes: { 'Crédito não aprovado': COR.vermelho, 'Comprou de concorrente': COR.vermelho } },
        { id: 'vi_c44', nome: 'Detalhamento', tipo: 'texto_longo', obrigatorio: false },
        { id: 'vi_c45', nome: 'Retomar contato em', tipo: 'data', obrigatorio: false },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Vai fazer proposta abre a etapa de proposta',
      etapaOrigemId: 'vi_e2',
      condicao: { campoId: 'vi_c14', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'vi_e3',
      etapaDestinoSenaoId: 'vi_e8',
    },
    {
      tipo: 'mover',
      nome: 'Proposta aceita vai para análise de crédito',
      etapaOrigemId: 'vi_e3',
      condicao: { campoId: 'vi_c18', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'vi_e4',
    },
    {
      tipo: 'mover',
      nome: 'Crédito aprovado libera o contrato',
      etapaOrigemId: 'vi_e4',
      condicao: { campoId: 'vi_c25', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'vi_e5',
      etapaDestinoSenaoId: 'vi_e8',
    },
    {
      tipo: 'mover',
      nome: 'Contrato assinado inicia o repasse',
      etapaOrigemId: 'vi_e5',
      condicao: { campoId: 'vi_c29', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'vi_e6',
    },
    {
      tipo: 'mover',
      nome: 'Recurso liberado conclui a venda',
      etapaOrigemId: 'vi_e6',
      condicao: { campoId: 'vi_c38', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'vi_e7',
    },
    {
      tipo: 'exibir_ocultar',
      nome: 'Contraproposta só quando recusar',
      etapaOrigemId: 'vi_e3',
      condicao: { campoId: 'vi_c18', operador: 'igual', valor: 'Não' },
      camposAfetadosIds: ['vi_c19'],
    },
    {
      tipo: 'exibir_ocultar',
      nome: 'Motivo da recusa do crédito',
      etapaOrigemId: 'vi_e4',
      condicao: { campoId: 'vi_c25', operador: 'igual', valor: 'Não' },
      camposAfetadosIds: ['vi_c27'],
    },
  ],
  cards: [
    { id: 'vi_card1', titulo: 'Marina Duarte - Apto 704 Prime', etapaId: 'vi_e4', etiquetas: ['Financiamento', 'Cliente Quente'], valores: { vi_c1: 'Marina Duarte - Apto 704 Prime', vi_c4: 'Apto 704 - Edifício Prime', vi_c5: 'Portal imobiliário', vi_c7: 'Financiamento bancário', vi_c15: 780000, vi_c16: 190000, vi_c22: 'Caixa Econômica', vi_c24: 590000 } },
    { id: 'vi_card2', titulo: 'Roberto Salles - Casa 18 Alto da Serra', etapaId: 'vi_e6', etiquetas: ['Financiamento'], valores: { vi_c1: 'Roberto Salles - Casa 18 Alto da Serra', vi_c4: 'Casa 18 - Alto da Serra', vi_c15: 640000, vi_c29: 'Sim', vi_c33: 'Aguardando registro', vi_c34: '2º Ofício de Registro' } },
    { id: 'vi_card3', titulo: 'Família Nakamura - Apto 302 Vista Verde', etapaId: 'vi_e3', valores: { vi_c1: 'Família Nakamura - Apto 302 Vista Verde', vi_c4: 'Apto 302 - Vista Verde', vi_c5: 'Plantão de vendas', vi_c15: 520000, vi_c16: 160000 } },
    { id: 'vi_card4', titulo: 'Paulo Andrade - Sala Comercial 12', etapaId: 'vi_e7', etiquetas: ['À Vista'], valores: { vi_c1: 'Paulo Andrade - Sala Comercial 12', vi_c4: 'Sala 12 - Edifício Prime', vi_c7: 'À vista', vi_c15: 410000, vi_c40: 24600, vi_c41: 'Não' } },
    { id: 'vi_card5', titulo: 'Cristina Melo - Apto 1102 Prime', etapaId: 'vi_e2', valores: { vi_c1: 'Cristina Melo - Apto 1102 Prime', vi_c4: 'Apto 1102 - Edifício Prime', vi_c5: 'Indicação', vi_c12: 'Alto' } },
    { id: 'vi_card6', titulo: 'Eduardo Pires - Casa 07 Alto da Serra', etapaId: 'vi_e1', valores: { vi_c1: 'Eduardo Pires - Casa 07 Alto da Serra', vi_c4: 'Casa 07 - Alto da Serra', vi_c5: 'Redes sociais', vi_c6: 600000 } },
    { id: 'vi_card7', titulo: 'Tatiane Rocha - Apto 108 Vista Verde', etapaId: 'vi_e8', valores: { vi_c1: 'Tatiane Rocha - Apto 108 Vista Verde', vi_c4: 'Apto 108 - Vista Verde', vi_c43: 'Crédito não aprovado', vi_c44: 'Restrição no CPF do cônjuge. Retomar em 6 meses.', vi_c45: '2027-02-10' } },
  ],
  tour: [
    '🔑 Funil imobiliário do primeiro contato até a chave na mão do cliente.',
    '1️⃣ "Atendimento": origem do lead e forma de pagamento pretendida logo de cara.',
    '2️⃣ "Visita": interesse e objeções registrados — é o que orienta a proposta.',
    '3️⃣ "Proposta": recusou? o campo de contraproposta aparece sozinho.',
    '4️⃣ "Análise de Crédito": checklist de documentos do banco, a etapa que mais trava venda.',
    '5️⃣ "Contrato": sinal recebido e instrumento anexado.',
    '📄 "Repasse e Registro": a etapa mais longa — cards ordenados pela previsão de liberação.',
    '💰 "Venda Concluída": comissão calculada e controlada no mesmo card.',
  ],
  etapasDicas: [
    { quemFaz: 'Corretor / SDR', objetivo: 'Qualificar antes de gastar visita.' },
    { quemFaz: 'Corretor', objetivo: 'Registrar objeção — é o que faz a proposta certa.', automacoes: ['Já configurado: sem proposta o card vai para perdido'] },
    { quemFaz: 'Corretor / Gerente', objetivo: 'Formalizar valor e condições por escrito.' },
    { quemFaz: 'Correspondente bancário', objetivo: 'Não deixar documento faltando travar o processo no banco.', automacoes: ['Já configurado: crédito negado vai para perdido com o motivo'] },
    { quemFaz: 'Jurídico / Administrativo', objetivo: 'Assinar com sinal registrado.' },
    { quemFaz: 'Correspondente / Cartório', objetivo: 'Acompanhar registro e liberação do recurso.' },
    { quemFaz: 'Financeiro', objetivo: 'Controlar a comissão do corretor.', conexoes: ['Ligue ao fluxo de Contas a Pagar para a comissão'] },
    { quemFaz: 'Corretor', objetivo: 'Guardar o motivo e a data para retomar o contato.' },
  ],
};

const locacaoImoveis: DefaultTemplate = {
  id: 'tpl_locacao_imoveis',
  name: 'Locação de Imóveis',
  descricao: 'Da captação do imóvel à entrega das chaves: divulgação, proposta, análise cadastral e garantia (fiador, seguro-fiança ou caução), contrato e vistoria de entrada com laudo fotográfico.',
  categoria: 'imobiliario',
  icone: '🏠',
  etiquetas: [
    { nome: 'Seguro-Fiança', cor: COR.azul },
    { nome: 'Fiador', cor: COR.roxo },
    { nome: 'Vago há +60 dias', cor: COR.vermelho },
  ],
  etapas: [
    {
      id: 'lo_e1', nome: 'Captação do Imóvel',
      tempoMaximoHoras: 72,
      camposVisiveisNoCard: ['lo_c1', 'lo_c3', 'lo_c5'],
      permiteMoverPara: ['lo_e2'],
      campos: [
        { id: 'lo_c1', nome: 'Imóvel', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'lo_c2', nome: 'Proprietário', tipo: 'texto', obrigatorio: true },
        { id: 'lo_c3', nome: 'Endereço', tipo: 'texto', obrigatorio: true },
        { id: 'lo_c4', nome: 'Tipo', tipo: 'lista', obrigatorio: true, opcoes: ['Apartamento', 'Casa', 'Sala comercial', 'Loja', 'Galpão', 'Terreno', 'Kitnet'] },
        { id: 'lo_c5', nome: 'Valor do Aluguel', tipo: 'valor', obrigatorio: true },
        { id: 'lo_c6', nome: 'Condomínio', tipo: 'valor', obrigatorio: false },
        { id: 'lo_c7', nome: 'IPTU Mensal', tipo: 'valor', obrigatorio: false },
        { id: 'lo_c8', nome: 'Contato do Proprietário', tipo: 'telefone', obrigatorio: false },
        { id: 'lo_c9', nome: 'Autorização de Locação', tipo: 'anexo', obrigatorio: false },
        { id: 'lo_c10', nome: 'Fotos do Imóvel', tipo: 'anexo', obrigatorio: false },
        { id: 'lo_c11', nome: 'Disponível a partir de', tipo: 'data', obrigatorio: false },
      ],
    },
    {
      id: 'lo_e2', nome: 'Divulgação e Visitas',
      camposVisiveisNoCard: ['lo_c1', 'lo_c5', 'lo_c13'],
      permiteMoverPara: ['lo_e3'],
      permiteCriarCards: false,
      campos: [
        { id: 'lo_c12', nome: 'Canais de Divulgação', tipo: 'checkbox_multi', obrigatorio: false, opcoes: ['Portal imobiliário', 'Site próprio', 'Redes sociais', 'Placa no imóvel', 'Carteira de clientes'] },
        { id: 'lo_c13', nome: 'Visitas Realizadas', tipo: 'numero', obrigatorio: false },
        { id: 'lo_c14', nome: 'Interessados', tipo: 'texto_longo', obrigatorio: false },
        { id: 'lo_c15', nome: 'Dias Vago', tipo: 'numero', obrigatorio: false },
        { id: 'lo_c16', nome: 'Recebeu proposta?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'lo_e3', nome: 'Proposta de Locação',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['lo_c1', 'lo_c17', 'lo_c21'],
      permiteMoverPara: ['lo_e4', 'lo_e7'],
      permiteCriarCards: false,
      campos: [
        { id: 'lo_c17', nome: 'Pretendente', tipo: 'texto', obrigatorio: true },
        { id: 'lo_c18', nome: 'Telefone do Pretendente', tipo: 'telefone', obrigatorio: false },
        { id: 'lo_c19', nome: 'Valor Proposto', tipo: 'valor', obrigatorio: false },
        { id: 'lo_c20', nome: 'Prazo do Contrato (meses)', tipo: 'numero', obrigatorio: false },
        { id: 'lo_c21', nome: 'Tipo de Garantia', tipo: 'lista', obrigatorio: true, opcoes: ['Fiador', 'Seguro-fiança', 'Caução em dinheiro', 'Título de capitalização', 'Sem garantia'], coresOpcoes: { 'Seguro-fiança': COR.azul, 'Fiador': COR.roxo, 'Sem garantia': COR.vermelho } },
        { id: 'lo_c22', nome: 'Proprietário aceitou?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'lo_e4', nome: 'Análise Cadastral',
      tempoMaximoHoras: 72,
      camposVisiveisNoCard: ['lo_c1', 'lo_c17', 'lo_c25'],
      permiteMoverPara: ['lo_e5', 'lo_e7'],
      permiteCriarCards: false,
      campos: [
        { id: 'lo_c23', nome: 'Documentos Recebidos', tipo: 'checkbox_multi', obrigatorio: false, opcoes: ['RG e CPF', 'Comprovante de renda', 'Comprovante de residência', 'Documentos do fiador', 'Matrícula do imóvel do fiador', 'Certidões negativas', 'Contrato social (PJ)'] },
        { id: 'lo_c24', nome: 'Renda Comprovada', tipo: 'valor', obrigatorio: false },
        { id: 'lo_c25', nome: 'Cadastro aprovado?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'lo_c26', nome: 'Restrições Encontradas', tipo: 'texto_longo', obrigatorio: false },
        { id: 'lo_c27', nome: 'Apólice / Documentos da Garantia', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'lo_e5', nome: 'Contrato e Vistoria',
      tempoMaximoHoras: 120,
      camposVisiveisNoCard: ['lo_c1', 'lo_c28', 'lo_c31'],
      permiteMoverPara: ['lo_e6'],
      permiteCriarCards: false,
      campos: [
        { id: 'lo_c28', nome: 'Contrato assinado?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'lo_c29', nome: 'Data de Início do Contrato', tipo: 'data', obrigatorio: false },
        { id: 'lo_c30', nome: 'Contrato (PDF)', tipo: 'anexo', obrigatorio: false },
        { id: 'lo_c31', nome: 'Vistoria de entrada realizada?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'lo_c32', nome: 'Laudo de Vistoria', tipo: 'anexo', obrigatorio: false },
        { id: 'lo_c33', nome: 'Leituras de Água e Luz', tipo: 'texto', obrigatorio: false },
      ],
    },
    {
      id: 'lo_e6', nome: 'Locado',
      camposVisiveisNoCard: ['lo_c1', 'lo_c17', 'lo_c34'],
      permiteCriarCards: false,
      campos: [
        { id: 'lo_c34', nome: 'Data de Entrega das Chaves', tipo: 'data', obrigatorio: false },
        { id: 'lo_c35', nome: 'Vencimento do Contrato', tipo: 'data_vencimento', obrigatorio: false },
        { id: 'lo_c36', nome: 'Dia de Vencimento do Aluguel', tipo: 'numero', obrigatorio: false },
        { id: 'lo_c37', nome: 'Taxa de Administração (%)', tipo: 'numero', obrigatorio: false },
        { id: 'lo_c38', nome: 'Observações', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'lo_e7', nome: 'Recusado',
      camposVisiveisNoCard: ['lo_c1', 'lo_c39'],
      permiteMoverPara: ['lo_e2'],
      permiteCriarCards: false,
      campos: [
        { id: 'lo_c39', nome: 'Motivo', tipo: 'lista', obrigatorio: true, opcoes: ['Cadastro reprovado', 'Garantia insuficiente', 'Proprietário recusou', 'Pretendente desistiu', 'Valor não acordado'], coresOpcoes: { 'Cadastro reprovado': COR.vermelho, 'Garantia insuficiente': COR.vermelho } },
        { id: 'lo_c40', nome: 'Detalhamento', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Proposta recebida abre a negociação',
      etapaOrigemId: 'lo_e2',
      condicao: { campoId: 'lo_c16', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'lo_e3',
    },
    {
      tipo: 'mover',
      nome: 'Proprietário aceitou vai para análise cadastral',
      etapaOrigemId: 'lo_e3',
      condicao: { campoId: 'lo_c22', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'lo_e4',
      etapaDestinoSenaoId: 'lo_e7',
    },
    {
      tipo: 'mover',
      nome: 'Cadastro aprovado libera o contrato',
      etapaOrigemId: 'lo_e4',
      condicao: { campoId: 'lo_c25', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'lo_e5',
      etapaDestinoSenaoId: 'lo_e7',
    },
    {
      tipo: 'mover',
      nome: 'Vistoria feita entrega as chaves',
      etapaOrigemId: 'lo_e5',
      condicao: { campoId: 'lo_c31', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'lo_e6',
    },
    {
      tipo: 'exibir_ocultar',
      nome: 'Restrições só quando reprovar o cadastro',
      etapaOrigemId: 'lo_e4',
      condicao: { campoId: 'lo_c25', operador: 'igual', valor: 'Não' },
      camposAfetadosIds: ['lo_c26'],
    },
  ],
  cards: [
    { id: 'lo_card1', titulo: 'Apto 51 - Ed. Aurora', etapaId: 'lo_e4', etiquetas: ['Seguro-Fiança'], valores: { lo_c1: 'Apto 51 - Ed. Aurora', lo_c2: 'Helena Barros', lo_c3: 'Rua das Acácias, 51', lo_c4: 'Apartamento', lo_c5: 2400, lo_c17: 'Bruno Tavares', lo_c21: 'Seguro-fiança', lo_c24: 9200 } },
    { id: 'lo_card2', titulo: 'Sala 402 - Centro Empresarial', etapaId: 'lo_e2', etiquetas: ['Vago há +60 dias'], valores: { lo_c1: 'Sala 402 - Centro Empresarial', lo_c2: 'Prime Empreendimentos', lo_c3: 'Av. Brasil, 900', lo_c4: 'Sala comercial', lo_c5: 3200, lo_c13: 7, lo_c15: 74 } },
    { id: 'lo_card3', titulo: 'Casa 22 - Bairro Jardim', etapaId: 'lo_e6', etiquetas: ['Fiador'], valores: { lo_c1: 'Casa 22 - Bairro Jardim', lo_c2: 'Antônio Ferraz', lo_c3: 'Rua das Palmas, 22', lo_c4: 'Casa', lo_c5: 3800, lo_c17: 'Família Moreira', lo_c21: 'Fiador', lo_c36: 10, lo_c37: 10 } },
    { id: 'lo_card4', titulo: 'Loja térrea - Rua XV', etapaId: 'lo_e5', valores: { lo_c1: 'Loja térrea - Rua XV', lo_c2: 'Espólio Ribeiro', lo_c3: 'Rua XV, 340', lo_c4: 'Loja', lo_c5: 6500, lo_c17: 'Padaria Estrela', lo_c28: 'Sim', lo_c31: 'Não' } },
    { id: 'lo_card5', titulo: 'Kitnet 03 - Vila Nova', etapaId: 'lo_e1', valores: { lo_c1: 'Kitnet 03 - Vila Nova', lo_c2: 'Marcos Aurélio', lo_c3: 'Rua Sete, 88', lo_c4: 'Kitnet', lo_c5: 1100 } },
    { id: 'lo_card6', titulo: 'Galpão 200m² - Distrito Industrial', etapaId: 'lo_e3', valores: { lo_c1: 'Galpão 200m² - Distrito Industrial', lo_c2: 'Logística Andrade', lo_c3: 'Rua Industrial, 15', lo_c4: 'Galpão', lo_c5: 8900, lo_c17: 'Distribuidora Sul', lo_c21: 'Caução em dinheiro' } },
    { id: 'lo_card7', titulo: 'Apto 12 - Ed. Girassol', etapaId: 'lo_e7', valores: { lo_c1: 'Apto 12 - Ed. Girassol', lo_c2: 'Célia Prado', lo_c3: 'Rua das Flores, 12', lo_c4: 'Apartamento', lo_c5: 1900, lo_c39: 'Garantia insuficiente', lo_c40: 'Fiador sem imóvel quitado na comarca.' } },
  ],
  tour: [
    '🏠 Imóvel captado, divulgado, alugado e entregue com laudo — tudo no mesmo card.',
    '1️⃣ "Captação": valor, condomínio, IPTU e autorização do proprietário.',
    '2️⃣ "Divulgação": canais, visitas e dias vago — o número que mais dói na carteira.',
    '3️⃣ "Proposta": tipo de garantia definido logo aqui, é o que trava depois.',
    '4️⃣ "Análise Cadastral": renda, documentos e restrições do pretendente.',
    '5️⃣ "Contrato e Vistoria": laudo fotográfico e leituras de água e luz anexados.',
    '🔑 "Locado": vencimento do contrato vira lembrete para a renovação.',
  ],
  etapasDicas: [
    { quemFaz: 'Captador / Corretor', objetivo: 'Registrar o imóvel com autorização assinada e fotos boas.' },
    { quemFaz: 'Marketing / Corretor', objetivo: 'Acompanhar dias vago — imóvel parado é receita perdida.', automacoes: ['Já configurado: proposta recebida abre a negociação'] },
    { quemFaz: 'Corretor', objetivo: 'Alinhar valor e garantia antes de abrir cadastro.', automacoes: ['Já configurado: proprietário recusou vai para recusado'] },
    { quemFaz: 'Análise / Administrativo', objetivo: 'Aprovar cadastro com renda e garantia compatíveis.', automacoes: ['Já configurado: cadastro reprovado registra a restrição'] },
    { quemFaz: 'Administrativo / Vistoriador', objetivo: 'Vistoria com foto é o que evita briga na saída.' },
    { quemFaz: 'Administração de Locação', objetivo: 'Controlar vencimento do contrato e taxa de administração.', conexoes: ['Ligue ao fluxo de Contas a Receber para o repasse ao proprietário'] },
    { quemFaz: 'Corretor', objetivo: 'Registrar o motivo e devolver o imóvel para divulgação.' },
  ],
};

const entregaUnidades: DefaultTemplate = {
  id: 'tpl_entrega_unidades',
  name: 'Entrega de Unidades',
  descricao: 'Repasse das unidades ao cliente: vistoria prévia interna, vistoria acompanhada pelo comprador, correção de pendências, entrega de chaves com termo assinado e manual do proprietário. Uma unidade por card.',
  categoria: 'imobiliario',
  icone: '🏘️',
  etiquetas: [
    { nome: 'Cliente Exigente', cor: COR.amarelo },
    { nome: 'Reagendada', cor: COR.vermelho },
    { nome: 'Entregue', cor: COR.verde },
  ],
  etapas: [
    {
      id: 'eu_e1', nome: 'Unidade Pronta',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['eu_c1', 'eu_c3', 'eu_c5'],
      permiteMoverPara: ['eu_e2'],
      campos: [
        { id: 'eu_c1', nome: 'Unidade', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'eu_c2', nome: 'Empreendimento', tipo: 'texto', obrigatorio: true },
        { id: 'eu_c3', nome: 'Comprador', tipo: 'texto', obrigatorio: true },
        { id: 'eu_c4', nome: 'Telefone do Comprador', tipo: 'telefone', obrigatorio: false },
        { id: 'eu_c5', nome: 'Data Prevista de Entrega', tipo: 'data_vencimento', obrigatorio: true },
        { id: 'eu_c6', nome: 'Situação Financeira', tipo: 'lista', obrigatorio: false, opcoes: ['Quitado', 'Financiamento liberado', 'Repasse em andamento', 'Pendência financeira'], coresOpcoes: { 'Quitado': COR.verde, 'Financiamento liberado': COR.verde, 'Pendência financeira': COR.vermelho } },
        { id: 'eu_c7', nome: 'Habite-se emitido?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'eu_e2', nome: 'Vistoria Prévia (interna)',
      tempoMaximoHoras: 72,
      camposVisiveisNoCard: ['eu_c1', 'eu_c9'],
      permiteMoverPara: ['eu_e3', 'eu_e4'],
      permiteCriarCards: false,
      campos: [
        { id: 'eu_c8', nome: 'Checklist Interno', tipo: 'checkbox_multi', obrigatorio: false, opcoes: ['Pintura e acabamento', 'Louças e metais', 'Esquadrias e vidros', 'Instalações elétricas testadas', 'Instalações hidráulicas testadas', 'Pisos e rodapés', 'Portas e fechaduras', 'Limpeza fina', 'Bancadas'] },
        { id: 'eu_c9', nome: 'Unidade aprovada internamente?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'eu_c10', nome: 'Pendências Internas', tipo: 'texto_longo', obrigatorio: false },
        { id: 'eu_c11', nome: 'Vistoriado por', tipo: 'texto', obrigatorio: false },
      ],
    },
    {
      id: 'eu_e3', nome: 'Vistoria com o Cliente',
      tempoMaximoHoras: 72,
      camposVisiveisNoCard: ['eu_c1', 'eu_c12', 'eu_c13'],
      permiteMoverPara: ['eu_e4', 'eu_e5', 'eu_e6'],
      permiteCriarCards: false,
      campos: [
        { id: 'eu_c12', nome: 'Data da Vistoria', tipo: 'data', obrigatorio: false },
        { id: 'eu_c13', nome: 'Cliente aprovou a unidade?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'eu_c14', nome: 'Apontamentos do Cliente', tipo: 'texto_longo', obrigatorio: false },
        { id: 'eu_c15', nome: 'Laudo de Vistoria Assinado', tipo: 'anexo', obrigatorio: false },
        { id: 'eu_c16', nome: 'Fotos da Vistoria', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'eu_e4', nome: 'Correção de Pendências',
      tempoMaximoHoras: 120,
      camposVisiveisNoCard: ['eu_c1', 'eu_c17', 'eu_c18'],
      permiteMoverPara: ['eu_e3'],
      permiteCriarCards: false,
      ordenacaoCards: 'vencimento_proximo',
      campos: [
        { id: 'eu_c17', nome: 'Responsável pela Correção', tipo: 'texto', obrigatorio: false },
        { id: 'eu_c18', nome: 'Prazo da Correção', tipo: 'data_vencimento', obrigatorio: false },
        { id: 'eu_c19', nome: 'Serviços Executados', tipo: 'texto_longo', obrigatorio: false },
        { id: 'eu_c20', nome: 'Custo da Correção', tipo: 'valor', obrigatorio: false },
        { id: 'eu_c21', nome: 'Correções concluídas?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'eu_e5', nome: 'Entrega de Chaves',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['eu_c1', 'eu_c3', 'eu_c22'],
      permiteCriarCards: false,
      campos: [
        { id: 'eu_c22', nome: 'Data da Entrega', tipo: 'data', obrigatorio: false },
        { id: 'eu_c23', nome: 'Itens Entregues', tipo: 'checkbox_multi', obrigatorio: false, opcoes: ['Chaves da unidade', 'Chave da caixa de correio', 'Controle de portão', 'Manual do proprietário', 'Termo de garantia', 'Termo de recebimento assinado', 'Leituras de água e luz'] },
        { id: 'eu_c24', nome: 'Termo de Entrega', tipo: 'anexo', obrigatorio: false },
        { id: 'eu_c25', nome: 'Recebido por', tipo: 'texto', obrigatorio: false },
        { id: 'eu_c26', nome: 'Observações Finais', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'eu_e6', nome: 'Entrega Suspensa',
      camposVisiveisNoCard: ['eu_c1', 'eu_c27'],
      permiteMoverPara: ['eu_e3', 'eu_e1'],
      permiteCriarCards: false,
      campos: [
        { id: 'eu_c27', nome: 'Motivo da Suspensão', tipo: 'lista', obrigatorio: true, opcoes: ['Pendência financeira do cliente', 'Repasse não concluído', 'Cliente não compareceu', 'Habite-se pendente', 'Unidade não aprovada', 'Cliente solicitou adiamento'], coresOpcoes: { 'Pendência financeira do cliente': COR.vermelho, 'Habite-se pendente': COR.amarelo } },
        { id: 'eu_c28', nome: 'Detalhamento', tipo: 'texto_longo', obrigatorio: false },
        { id: 'eu_c29', nome: 'Nova Data Prevista', tipo: 'data_vencimento', obrigatorio: false },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Aprovada internamente agenda a vistoria com o cliente',
      etapaOrigemId: 'eu_e2',
      condicao: { campoId: 'eu_c9', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'eu_e3',
      etapaDestinoSenaoId: 'eu_e4',
    },
    {
      tipo: 'mover',
      nome: 'Cliente aprovou libera a entrega de chaves',
      etapaOrigemId: 'eu_e3',
      condicao: { campoId: 'eu_c13', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'eu_e5',
      etapaDestinoSenaoId: 'eu_e4',
    },
    {
      tipo: 'mover',
      nome: 'Correções feitas voltam para nova vistoria',
      etapaOrigemId: 'eu_e4',
      condicao: { campoId: 'eu_c21', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'eu_e3',
    },
    {
      tipo: 'exibir_ocultar',
      nome: 'Apontamentos do cliente quando não aprovar',
      etapaOrigemId: 'eu_e3',
      condicao: { campoId: 'eu_c13', operador: 'igual', valor: 'Não' },
      camposAfetadosIds: ['eu_c14'],
    },
  ],
  cards: [
    { id: 'eu_card1', titulo: 'Apto 704 - Edifício Prime', etapaId: 'eu_e4', etiquetas: ['Cliente Exigente'], valores: { eu_c1: 'Apto 704 - Edifício Prime', eu_c2: 'Edifício Comercial Prime', eu_c3: 'Ana Ribeiro', eu_c6: 'Financiamento liberado', eu_c13: 'Não', eu_c14: 'Riscos no vidro da sacada e porta do banheiro desalinhada.', eu_c18: '2026-08-22' } },
    { id: 'eu_card2', titulo: 'Apto 302 - Vista Verde', etapaId: 'eu_e5', etiquetas: ['Entregue'], valores: { eu_c1: 'Apto 302 - Vista Verde', eu_c2: 'Residencial Vista Verde', eu_c3: 'Família Nakamura', eu_c6: 'Quitado', eu_c22: '2026-08-08', eu_c25: 'Hiroshi Nakamura' } },
    { id: 'eu_card3', titulo: 'Casa 18 - Alto da Serra', etapaId: 'eu_e3', valores: { eu_c1: 'Casa 18 - Alto da Serra', eu_c2: 'Condomínio Alto da Serra', eu_c3: 'Roberto Salles', eu_c6: 'Repasse em andamento', eu_c7: 'Sim' } },
    { id: 'eu_card4', titulo: 'Apto 1102 - Edifício Prime', etapaId: 'eu_e2', valores: { eu_c1: 'Apto 1102 - Edifício Prime', eu_c2: 'Edifício Comercial Prime', eu_c3: 'Rogério Lima', eu_c6: 'Financiamento liberado' } },
    { id: 'eu_card5', titulo: 'Apto 108 - Vista Verde', etapaId: 'eu_e6', etiquetas: ['Reagendada'], valores: { eu_c1: 'Apto 108 - Vista Verde', eu_c2: 'Residencial Vista Verde', eu_c3: 'Sandra Vieira', eu_c27: 'Pendência financeira do cliente', eu_c28: 'Saldo devedor de R$ 34.000 não quitado. Comercial acionado.' } },
    { id: 'eu_card6', titulo: 'Casa 22 - Alto da Serra', etapaId: 'eu_e1', valores: { eu_c1: 'Casa 22 - Alto da Serra', eu_c2: 'Condomínio Alto da Serra', eu_c3: 'Juliana Prates', eu_c6: 'Quitado', eu_c7: 'Sim' } },
  ],
  tour: [
    '🏘️ Uma unidade por card — dá para entregar uma torre inteira sem perder o controle.',
    '1️⃣ "Unidade Pronta": situação financeira e habite-se conferidos antes de chamar o cliente.',
    '2️⃣ "Vistoria Prévia": a construtora acha o defeito antes do comprador.',
    '3️⃣ "Vistoria com o Cliente": reprovou? o card vai direto para correção com os apontamentos.',
    '4️⃣ "Correção": prazo e custo por unidade registrados.',
    '🔑 "Entrega de Chaves": checklist do que foi entregue e termo assinado anexado.',
    '⏸️ "Entrega Suspensa": pendência financeira ou cliente ausente não some do quadro.',
  ],
  etapasDicas: [
    { quemFaz: 'Engenharia / Administrativo', objetivo: 'Só chamar o cliente com financeiro e habite-se resolvidos.' },
    { quemFaz: 'Engenheiro / Qualidade', objetivo: 'Vistoriar antes do cliente — é o que evita vistoria reprovada.', automacoes: ['Já configurado: reprovada internamente vai para correção'] },
    { quemFaz: 'Engenheiro + Comprador', objetivo: 'Registrar apontamentos com laudo assinado pelas duas partes.' },
    { quemFaz: 'Equipe de Acabamento', objetivo: 'Corrigir no prazo prometido na vistoria.', automacoes: ['Já configurado: correções concluídas voltam para nova vistoria'] },
    { quemFaz: 'Relacionamento / Engenharia', objetivo: 'Entregar com manual e termo de garantia.', conexoes: ['Ligue à "Assistência Técnica" — a garantia começa a contar aqui'] },
    { quemFaz: 'Comercial / Administrativo', objetivo: 'Destravar a pendência e reagendar.' },
  ],
};

export const TEMPLATES_IMOBILIARIO: DefaultTemplate[] = [
  viabilidadeTerreno,
  aprovacaoProjetos,
  vendasImoveis,
  locacaoImoveis,
  entregaUnidades,
];
